export default __webpack_public_path__ + "static/media/txt3_sp.4a5bca20.png";